import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { useGetCatalogQuery } from '../../../../redux/api/fymAPI';
import { AssetViewer } from '../viewer/AssetViewer';
import { fileOfAssetUuid, PostsBoardFile, postFileViewerItem, viewerItemsOfSong } from './postsModel';

interface PostsFileViewerProps {
  accountId: number;
  /** The `?asset=` of the address: the shown revision of a file. */
  assetUuid: string | undefined;
  /** The files the viewer may show; it steps through the ready files of the same song. */
  files: ReadonlyArray<PostsBoardFile>;
  onClose: () => void;
}

/**
 * The asset viewer of the Posts page (design assets-rethink c1: "A click on a file opens the
 * viewer"). The open file lives in the address (`?asset=`), so a refresh opens it again and Back
 * closes it. "Post it" works for a reel too, as on the release page.
 */
const PostsFileViewerComponent: React.FC<PostsFileViewerProps> = ({ accountId, assetUuid, files, onClose }) => {
  const file = useMemo(() => (assetUuid === undefined ? null : fileOfAssetUuid(files, assetUuid)), [assetUuid, files]);
  const catalogItemUuid = file?.catalogItemUuid ?? null;
  const catalog = useGetCatalogQuery({ accountId }, { skip: catalogItemUuid === null });
  const song = useMemo(
    () => catalog.data?.items.find((item) => item.uuid === catalogItemUuid),
    [catalog.data, catalogItemUuid]
  );
  const items = useMemo(
    () => (catalogItemUuid === null ? [] : viewerItemsOfSong(files, catalogItemUuid)),
    [catalogItemUuid, files]
  );
  const start = useMemo(() => (file === null ? null : postFileViewerItem(file)), [file]);

  if (song === undefined || start === null) {
    return null;
  }
  return (
    <AssetViewer accountId={accountId} song={song} items={items} startKey={start.key} allowReelPost onClose={onClose} />
  );
};

export const PostsFileViewer = TypedMemo(PostsFileViewerComponent);
